import React from "react";

const Bash_Cd = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Cd</h2>
      <p>Change the current directory.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>cd [directory]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>cd /var/log
cd ~   # go to home
cd -   # previous directory</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Using no argument or ~ goes to the user's home directory.</p>
    </div>
  );
};

export default Bash_Cd;
